import { useCallback, useEffect, useState } from 'react';

export default function useDeferredDrawerClose({ onExited, open }: { onExited?: () => void; open: boolean }): {
  animateThen: (action: () => void) => void;
  drawerOpen: boolean;
  handleExited: () => void;
} {
  const [pendingCloseAction, setPendingCloseAction] = useState<null | (() => void)>(null);

  useEffect(() => {
    if (open) {
      setPendingCloseAction(null);
    }
  }, [open]);

  const animateThen = useCallback((action: () => void) => {
    setPendingCloseAction(() => action);
  }, []);

  const handleExited = useCallback(() => {
    const action = pendingCloseAction;
    setPendingCloseAction(null);
    onExited?.();

    // Changing workflow state before the top drawer exits makes the drawer
    // underneath re-render while it is still visible through the transition.
    action?.();
  }, [onExited, pendingCloseAction]);

  return {
    animateThen,
    drawerOpen: open && !pendingCloseAction,
    handleExited,
  };
}
